import { FC, useState } from 'react';
import { Modal } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import { CloseOutlined } from '@ant-design/icons';
import NAPDownloadModalContent from './NAPDownloadModalContent';
import './NAPDownloadModal.css';
import { getNAPDetail } from '@/libs/fleet-api/services/nap';
import { useQuery } from '@tanstack/react-query';
import NAPDownloadModalContentJF from './NAPDownloadModalContentJF';

export type NAPDownloadModalState = {
	prospectId: string;
	autoClose?: boolean;
};

type NAPDownloadModalProps = {
	modal: NAPDownloadModalState | null;
	onClose: () => void;
};

export const useNAPDownloadModal = () => {
	return useState<NAPDownloadModalState | null>(null);
};

const NAPDownloadModal: FC<NAPDownloadModalProps> = ({ modal, onClose }) => {
	// const [contentElement, setContentElement] = useState<HTMLDivElement | null>(
	// 	null,
	// );

	// const contentRef = useCallback((node: HTMLDivElement | null) => {
	// 	if (node) {
	// 		setContentElement(node);
	// 	}
	// }, []);

	// Reset content element when modal closes
	// useEffect(() => {
	// 	if (!modal) {
	// 		setContentElement(null);
	// 	}
	// }, [modal]);

	const { prospectId } = modal ?? {};

	const { isLoading, data } = useQuery({
		queryKey: ['getNAPDetail', prospectId] as const,
		queryFn: ({ queryKey }) => {
			const [, id] = queryKey;
			if (!id) return null;
			return getNAPDetail(id);
		},
	});

	const isNAPNJF = (!isLoading && data?.data?.internalCompliance) ?? false;

	if (!modal) return null;

	return (
		<>
			<Modal
				open={!!modal}
				onCancel={onClose}
				width="100vw"
				style={{
					maxWidth: '100vw',
					top: 0,
					paddingBottom: 0,
					margin: 0,
				}}
				footer={null}
				closeIcon={
					<CloseOutlined
						style={{
							fontSize: 20,
							color: '#fff',
							background: '#1557BC',
							padding: 8,
							borderRadius: '50%',
						}}
					/>
				}
				className="nap-download-modal"
			>
				<div
					// ref={contentRef}
					style={{
						display: 'flex',
						justifyContent: 'center',
						width: '100vw',
						height: 'auto',
						backgroundColor: '#fff',
						margin: '0 auto',
					}}
					id="nap-download-modal"
				>
					{isLoading && !data ? (
						<LoadingOutlined
							style={{
								marginTop: 160,
								fontSize: 100,
								color: '#1557BC',
								display: 'block',
							}}
						/>
					) : (
						<>
							{isNAPNJF ? (
								<NAPDownloadModalContent
									prospectId={modal.prospectId}
									onClose={onClose}
								/>
							) : (
								<NAPDownloadModalContentJF
									prospectId={modal.prospectId}
									onClose={onClose}
								/>
							)}
						</>
					)}
					{/* <NAPDownloadModalContent
						prospectId={modal.prospectId}
						onClose={onClose}
					/> */}
				</div>
			</Modal>
		</>
	);
};

export default NAPDownloadModal;
